import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { SITE } from "@/data/site";

function CountUp({ to, suffix = "", duration = 1.6 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const target = parseInt(to, 10) || 0;
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / (duration * 1000));
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration]);

  return (
    <span ref={ref} className="tabular-nums">
      {val}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section
      id="stats"
      data-testid="stats-section"
      className="relative bg-[#0B0B0E] text-white border-y border-white/[0.05]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6">
        {SITE.stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="flex flex-col items-start md:items-center text-left md:text-center md:border-l md:first:border-l-0 md:border-white/10 md:px-6"
            data-testid={`stat-${i}`}
          >
            <div className="font-serif text-5xl lg:text-6xl text-[#F5A623] tracking-tight">
              <CountUp to={s.value} suffix={s.suffix} />
            </div>
            <p className="mt-3 text-sm uppercase tracking-[0.22em] text-[#9CA0AA]">
              {s.label}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
